import React, {useState} from 'react';
import ColorVectorizer from "./vectorizer";
import CameraSegmenterPaperJS from "./segmenter";


const All = () => {
    // We now store a payload containing the canvas AND the raw AI mask data
    const [capturePayload, setCapturePayload] = useState(null);

    return (
        <div style={{ padding: '20px' }}>
            <h1>AI Segmentation & Vectorization Pipeline</h1>

            <CameraSegmenterPaperJS onImageGrabbed={(payload) => setCapturePayload(payload)} />

            <hr style={{ margin: '40px 0', borderColor: '#ccc' }} />

            {/* Pass the entire payload to the vectorizer */}
            <ColorVectorizer captureData={capturePayload} />
        </div>
    );
};

export default All;